import classNames from 'classnames';
import { FC, memo } from 'react';

import { Button, ButtonProps } from 'ui/Button/Button';

type PropTypes = {
  active: string;
  className?: string;
  buttons: Array<ButtonProps & { text: string; id: string }>;
  onClick?: (type: string) => void;
};

const ButtonGroup: FC<PropTypes> = ({
  buttons,
  active,
  onClick,
  className,
}) => {
  const handleClick = (type: string) => () => {
    if (onClick) onClick(type);
  };

  return (
    <div className={classNames('button-group', className)}>
      {buttons.map((item, index) => (
        <Button
          key={index}
          {...item}
          variant={active === item.id ? 'primary' : 'icon'}
          onClick={handleClick(item.id)}
          className={classNames('button-group__button', {
            'button-group__button-active': active === item.id,
          })}
        >
          {item.text}
        </Button>
      ))}
    </div>
  );
};

export default memo(ButtonGroup);
